module.exports = __webpack_public_path__ + "static/img/csnl.0cae958.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/csnl.png
// module id = 5MKo
// module chunks = 1